const LOAD_DATA_MASTER_JOB_DESTINATIONS           = 'LOAD_DATA_MASTER_JOB_DESTINATIONS'
const LOAD_DATA_MASTER_JOB_DESTINATIONS_SUCCESS   = 'LOAD_DATA_MASTER_JOB_DESTINATIONS_SUCCESS'
const LOAD_DATA_MASTER_JOB_DESTINATIONS_FAILED    = 'LOAD_DATA_MASTER_JOB_DESTINATIONS_FAILED'
const UNMOUNT_DATA_MASTER_JOB_DESTINATIONS        = 'UNMOUNT_DATA_MASTER_JOB_DESTINATIONS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterJobDestinationsReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_JOB_DESTINATIONS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_JOB_DESTINATIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_JOB_DESTINATIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_JOB_DESTINATIONS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterJobDestinationsReducer;